import { render, staticRenderFns } from "./user.vue?vue&type=template&id=66069e68&scoped=true"
import script from "./user.vue?vue&type=script&lang=js"
export * from "./user.vue?vue&type=script&lang=js"
import style0 from "./user.vue?vue&type=style&index=0&id=66069e68&prod&lang=scss"
import style1 from "./user.vue?vue&type=style&index=1&id=66069e68&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66069e68",
  null
  
)

export default component.exports